import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import Buscador from "../../Buscador/Buscador"
import Cardsimple from "../../cards/Cardsimple"
import Pagination from "../../pagination/Pagination"
import getAlmacen from "../../services/almacen/getAlmacen"
import Topnavbar from "../../sections/Topnavbar"
import TableAlmacen from "./TableAlmacen"
import { Helmet, HelmetProvider } from "react-helmet-async"
import Leftnavbar from "../../sections/Leftnavbar"
import Footerbar from "../../sections/Footerbar"

const Almacen = () => {
    let { search } = useLocation()
    let query = new URLSearchParams(search)
    let busqueda = query.get("bus") || ""
    let paginaURL = query.get("pag") || 1
    let filtro = query.get("fil") || ""
    let paginaAPI = 1
    let totalResultados = 0
    let totalPaginas = 1
    let tamanioPagina = 1

    const [repuestosAlmacen, setRepuestosAlmacen] = useState()

    useEffect(() => {
        getAlmacen(busqueda, paginaURL, filtro)
            .then((data) => {
                if (data.error === 401) {
                    setRepuestosAlmacen(401)
                }
                else {
                    setRepuestosAlmacen(data)
                }
                window.scrollTo(0, 0)
                ocultarImagenes()
            })
    }, [busqueda, paginaURL, filtro])

    if (repuestosAlmacen) {
        totalResultados = repuestosAlmacen.totalResultados
        totalPaginas = repuestosAlmacen.totalPaginas
        tamanioPagina = repuestosAlmacen.tamanioPagina
        paginaAPI = repuestosAlmacen.paginaActual
    }

    function ocultarImagenes() {
        let element = document.getElementsByClassName('collapse show');
        Array.from(element).forEach(function (data) {
            data.classList.remove("show")
        });

    }

    const Titulo = () => { return (<span className="font-weight-light">{" : \"" + busqueda.charAt(0).toUpperCase() + busqueda.slice(1)}"</span>) }
    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>ALMACEN DE ESSALUD</title>
                </Helmet>
            </HelmetProvider>
            <Leftnavbar />
            <Topnavbar titulo={<>Almacén EsSalud {(busqueda) && <Titulo />}</>} />
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-9">
                                <h1 className="m-0">{<>Almacén de <span style={{ color: "#0066cc", fontWeight: "bold" }}>EsSalud</span></>}

                                    {<>{(busqueda) && <Titulo />}</>}
                                </h1>
                            </div>
                            <div className="col-lg-3">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="#">Home</a></li>
                                    <li className="breadcrumb-item active">Almacén de EsSalud</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12 text-sm">
                                <Cardsimple
                                    style={``}
                                    condensed={true}
                                    header={
                                        <div className="row">
                                            <div className="col-md-7">
                                                <Buscador
                                                    dataBusqueda={busqueda}
                                                    dataPagina="almacen"
                                                />
                                            </div>
                                            <div className="col-md-5">
                                                <Pagination
                                                    busqueda={busqueda}
                                                    page="almacen"
                                                    pagActual={paginaURL}
                                                    pagAPI={paginaAPI}
                                                    totalPaginas={totalPaginas}
                                                    filtroValue={filtro}
                                                />
                                            </div>
                                        </div>
                                    }
                                >
                                </Cardsimple>
                                <Cardsimple
                                    condensed={true}
                                    footer={
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="p-1">Resultados de la búsqueda :  {totalResultados}</div>
                                            </div>
                                            <div className="col-md-8">
                                                <Pagination
                                                    busqueda={busqueda}
                                                    page="almacen"
                                                    pagActual={paginaURL}
                                                    pagAPI={paginaAPI}
                                                    totalPaginas={totalPaginas}
                                                    filtroValue={filtro}
                                                />
                                            </div>
                                        </div>
                                    }
                                >
                                    {
                                        (repuestosAlmacen) && (
                                            <TableAlmacen datos={repuestosAlmacen} />
                                        )
                                    }
                                </Cardsimple>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footerbar />
        </>
    )
}
export default Almacen